var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasValue)?_c('a',{staticClass:"btn btn-sm",on:{"click":_vm.copy}},[_c('i',{staticClass:"far fa-copy"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }